import { render, staticRenderFns } from "./OpenBookingPayByMethod.vue?vue&type=template&id=c2c4fb54&scoped=true"
import script from "./OpenBookingPayByMethod.vue?vue&type=script&lang=js"
export * from "./OpenBookingPayByMethod.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingPayByMethod.vue?vue&type=style&index=0&id=c2c4fb54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4fb54",
  null
  
)

export default component.exports